<template>
  <ya-site-resource-list resource="image" />
</template>

<script>
import YaSiteResourceList from './resourceList'

export default {
  name: 'YaSiteHotelImageList',
  components: { YaSiteResourceList },
}
</script>
